// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/tarifarios',
    name: 'tarifarios',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/booking/tarifarios/List.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'tarifarios',
    },
  },
]

export default formTable
